import React, { Fragment } from 'react';
import { Chip, Dialog, DialogContent, Grid, Box, Typography, Button, Skeleton, Stack, IconButton } from '@mui/material';
import _ from 'lodash';
import Card from '../dish-menu-creator/Card';
import GlobalNotification from '../../component/common/snackbar';
import { IOSSwitch } from '../../component/switch/IOSSwitch';
import { apiManage_rbp } from '../../request';
import './scss/business-hour.scss';
import './scss/business-hour-compound.scss';
import { ReactComponent as MingcuteCloseFillIcon } from '../../static/images/svg/mingcute_close-fill.svg';
import { ReactComponent as IcRoundPlusIcon } from '../../static/images/svg/ic_round-plus.svg';
import setLoading from '../../component/linear-determinate';

import Table from '../../component/table/table';
import { MUIDataTableColumnDef } from 'mui-datatables';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import moment from 'moment';
import { generateBusinessHour2, getDate, timeDifference } from '../../constants/utils';
import { BusinessHour2, BusinessHourValue, FirstMenu, PostBusinessHour2Params } from '../../models';
import BusinessHourCompound from './business-hour-compound';
import i18n from '../../i18n';
import CommonInput from '../../component/form/common-input.component';
import ButtonComponent from '../../component/button/button.component';
class BusinessHourPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.save = _.debounce(this.save, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
        this.onSave = _.debounce(this.onSave, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }

    public state: Readonly<State> = {
        // 菜单列表
        menuList: [],
        // 复合型营业时间数据
        businessHour2: [],
        isComplex: false,
        // 必选菜单
        requiredMenu: [],
        // 隐藏菜单
        hideMenu: [],
        // 选中菜单
        selectMenu: [],
        oldRequiredMenu: [],
        oldHideMenu: [],
        tables: [],
        deleteOpen: false,
        currentId: 0,
        addNewBusinessHours: false,
        // 首选菜单
        preferredMenu: [],
        // 备选菜单
        alternativeMenu: [],
        endTime: '00:00',
        startTime: '00:00',
        isRepeatedly: false,
        // 轮次时间
        turn_mins: 0,
        // 每人每轮点餐数量
        turn_dishes: 0,
        // 最大点餐回合数
        max_turn: 0,
        /** 首次初始化完成前展示骨架屏，避免营业时间区块空白闪烁 */
        initialLoadReady: false,
        /** 简单模式：必选/隐藏菜单 — 与复合型相同的「新增菜单」弹窗 */
        simpleMenuModal: null,
    }

    savingGuestClosing: boolean = false;

    /**
     * 父级餐厅基本信息页带隧道校验装饰器时，校验会替换整页 render，本组件可能短时间卸载再挂载；
     * 或 CURRENT_RESTAURANT 再次触发校验导致重复 componentDidMount。
     * 合并同实例上并发的 initBusinessHour2，避免 get_menus_v3 / get_business_hour2 被连打两次。
     */
    private businessHour2InitInFlight: Promise<void> | null = null;

    // *********************
    // Life Cycle Function
    // *********************

    async componentDidMount() {
        if (!this.businessHour2InitInFlight) {
            this.businessHour2InitInFlight = this.initBusinessHour2AndInit().finally(() => {
                this.businessHour2InitInFlight = null;
            });
        }
        await this.businessHour2InitInFlight;
    }

    // *********************
    // Default Function
    // *********************
    async initBusinessHour2AndInit() {
        try {
            await Promise.all([
                this.init(),
                this.initBusinessHour2(),
            ]);
        } finally {
            setLoading(false);
            this.setState({ initialLoadReady: true });
        }
    }
    async init() {
        try {
            setLoading(true);
            const result = await apiManage_rbp.get_set_business_hour();
            if (result.error) {
                GlobalNotification.error(i18n.t('business_hour_page_get_opening_time_setup_failed'));
                setLoading(false);
            } else {
                this.setState({
                    isComplex: _.get(result, '[0].value', '0') === '0' ? false : true,
                }, async () => {
                    const businessTable = await this.getBusinessHour();
                    const returnObj = await this.getSettingValue();
                    const turn_mins = _.get(returnObj, 'turn_mins', 0);
                    const turn_dishes = _.get(returnObj, 'turn_dishes', 0);
                    const max_turn = _.get(returnObj, 'max_turn', 0);
                    const default_menu = _.get(returnObj, 'default_menu', []);
                    const hide_menu = _.get(returnObj, 'hide_menu', []);

                    this.setState({
                        requiredMenu: default_menu,
                        hideMenu: hide_menu,
                        oldHideMenu: hide_menu,
                        oldRequiredMenu: default_menu,
                        tables: businessTable,
                        deleteOpen: false,
                        addNewBusinessHours: false,
                        startTime: '00:00',
                        endTime: '00:00',
                        alternativeMenu: [],
                        preferredMenu: [],
                        currentId: 0,
                        turn_mins,
                        turn_dishes,
                        max_turn
                    })
                })
                setLoading(false);
            }
        } catch (error) {

        }
    }

    /**
     * 初始化营业时间表格
     */
    async initBusinessHourTable() {
        const businessTable = await this.getBusinessHour();
        this.setState({
            tables: businessTable,
            deleteOpen: false,
            addNewBusinessHours: false,
            startTime: '00:00',
            endTime: '00:00',
            alternativeMenu: [],
            preferredMenu: [],
            currentId: 0
        })
    }

    /**
     * 获取营业时间
     */
    async getBusinessHour() {
        try {
            const result = await apiManage_rbp.get_v2_business_hour();
            if (result.error) {
                GlobalNotification.error(i18n.t('business_hour_page_get_opening_time_failed'));
                return []
            } else {
                return result
            }
        } catch (error) {

        }
    }

    /**
     * 获取已选菜单
     */
    async getSetting(id: number) {
        try {
            const result = await apiManage_rbp.get_setting(id);
            if (result.error) {
                GlobalNotification.error(i18n.t('business_hour_page_get_selected_menu_failed'));
                return [];
            } else {
                // 19 默认菜单  20 默认隐藏菜单
                return id === 19 ? _.get(result, '[0].value.defaultMenu', []) : _.get(result, '[0].value.hideMenu', [])
            }
        } catch (error) {

        }
    }

    /**
     * 获取设置
     */
    async getSettingValue() {
        const requestQueue: Record<string, {
            key: string;
            valueField?: string;
            rejected: () => void;
            request: () => Promise<{ id: number; name: string; value: any; }[]>;
        }> = {
            // 获取/修改每人每轮点菜数和点餐时间
            2: {
                key: 'turn_dishes',
                rejected: () => GlobalNotification.error(i18n.t('self_order_setting_page_get_round_rule_faile')),
                request: async () => await apiManage_rbp.get_setting(2),
            },
            // 获取/修改最大点餐回合数
            9: {
                key: 'max_turn',
                rejected: () => GlobalNotification.error(i18n.t('self_order_setting_page_get_max_order_round_amount_failed')),
                request: async () => await apiManage_rbp.get_setting(9),
            },
            //
            19: {
                key: 'default_menu',
                valueField: 'defaultMenu',
                rejected: () => GlobalNotification.error(i18n.t('business_hour_page_get_selected_menu_failed')),
                request: async () => await apiManage_rbp.get_setting(19),
            },
            //
            20: {
                key: 'hideMenu',
                valueField: 'hideMenu',
                rejected: () => GlobalNotification.error(i18n.t('business_hour_page_get_selected_menu_failed')),
                request: async () => await apiManage_rbp.get_setting(20),
            }
        }
        const result = await Promise.allSettled(Object.values(requestQueue).map(item => item.request?.()));
        const returnObj: Record<string, any> = {};
        result.forEach((resuleItem, index) => {
            if (resuleItem.status === 'rejected' || _.get(resuleItem, '.value.error')) {
                Object.values(requestQueue)[index]?.rejected();
            } else {
                const item = resuleItem.value;
                const id = _.get(item, ['0', 'id']);
                const value = _.get(item, ['0', 'value']);
                const { key, valueField } = requestQueue?.[id] || {};
                // 判断取value还是取value下面的某个值
                const formatValue = valueField ? value?.[valueField] : value;
                if (id === 2) {
                    _.set(returnObj, 'turn_mins', value.turn_mins || 0)
                    _.set(returnObj, 'turn_dishes', value.turn_dishes || 0)
                } else if (key) {
                    _.set(returnObj, key, formatValue)
                }
            }
        })
        return returnObj
    }

    /**
     * 切换营业时间设置
     */
    async onChange() {
        this.setState({
            isComplex: !this.state.isComplex
        }, async () => {
            const result = await apiManage_rbp.patch_set_business_hour({
                set_business_hour: this.state.isComplex ? '1' : '0'
            });
            if (result === 'success') {
                GlobalNotification.success(i18n.t('business_hour_page_change_opening_time_succeed'))
            } else {
                GlobalNotification.error(i18n.t('business_hour_page_chang_opening_time_failed'))
            }
        })
    }

    /**
     * 修改菜单数据选中设置
     */
    onChangeMenu = (id: number, index: number, menuData: Array<number>) => {
        let data: number[] = _.cloneDeep(menuData);
        if (_.indexOf(menuData, id) > -1) {
            data = _.filter(data, item => {
                return item !== id
            })
        } else {
            data.push(id)
        }
        // 必选菜单
        if (index === 1) {
            this.setState({
                requiredMenu: data
            })
            // 默认隐藏菜单
        } else if (index === 2) {
            this.setState({
                hideMenu: data
            })
            // 首选菜单
        } else if (index === 3) {
            this.setState({
                preferredMenu: data
            })
            // 备选菜单
        } else if (index === 4) {
            this.setState({
                alternativeMenu: data
            })
        }

    }

    /** 简单模式「新增菜单」弹窗关闭 */
    closeSimpleMenuModal = () => this.setState({ simpleMenuModal: null });

    /** 简单模式：菜单主类别展示名 */
    simpleMenuLabel(mainGroupId: number) {
        const item = this.state.menuList.find((m) => m.main_group_id === mainGroupId);
        return item?.main_group_name || String(mainGroupId);
    }

    /**
     * 弹窗内选项是否禁用：必选/隐藏互斥；新增时段内首选/备选与必选、隐藏及彼此约束一致。
     */
    simpleMenuModalOptionDisabled(
        kind: 'required' | 'hide' | 'preferred' | 'alternative',
        menuIdStr: string,
        active: boolean
    ) {
        if (active) {
            return false;
        }
        const id = Number(menuIdStr);
        if (Number.isNaN(id)) {
            return true;
        }
        if (kind === 'required') {
            return this.state.hideMenu.includes(id);
        }
        if (kind === 'hide') {
            return this.state.requiredMenu.includes(id);
        }
        if (kind === 'preferred') {
            return (
                this.state.hideMenu.includes(id) ||
                this.state.requiredMenu.includes(id) ||
                this.state.alternativeMenu.includes(id)
            );
        }
        return (
            this.state.hideMenu.includes(id) ||
            this.state.requiredMenu.includes(id) ||
            this.state.preferredMenu.includes(id)
        );
    }

    /**
     * 修改营业菜单设置
     */
    async patch_setting(id: number, param: any) {
        try {
            setLoading(true);
            const result = await apiManage_rbp.patch_setting(id, param);
            if (result.error) {
                GlobalNotification.error(i18n.t('business_hour_page_modify_menu_select_failed'));
                this.setState({
                    isRepeatedly: false
                })
            } else {
                const resultDefaultMenu = await this.getSetting(19);
                const resultHideMenu = await this.getSetting(20);
                this.setState({
                    requiredMenu: resultDefaultMenu,
                    hideMenu: resultHideMenu,
                    oldHideMenu: resultHideMenu,
                    oldRequiredMenu: resultDefaultMenu,
                    isRepeatedly: false
                })
                setLoading(false);
            }
        } catch (error) {

        }
    }

    /**
     * 保存菜单修改
     */
    save = async () => {
        const { requiredMenu, hideMenu } = this.state
        console.log(requiredMenu, hideMenu);
        setLoading(true);
        if (JSON.stringify(this.state.oldRequiredMenu) !== JSON.stringify(requiredMenu) && !this.state.isRepeatedly) {
            this.setState({
                isRepeatedly: true
            }, async () => {
                await this.patch_setting(19, {
                    defaultMenu: requiredMenu.filter(id => {
                        return this.state.menuList.find(item => item.main_group_id === id)
                    })
                });
            })
        }
        if (JSON.stringify(this.state.oldHideMenu) !== JSON.stringify(hideMenu && !this.state.isRepeatedly)) {
            this.setState({
                isRepeatedly: true
            }, async () => {
                await this.patch_setting(20, {
                    hideMenu: hideMenu.filter(id => {
                        return this.state.menuList.find(item => item.main_group_id === id)
                    })
                })
            })
        }
        setLoading(false);
    }

    /**
     * 删除一个营业时间数据
     */
    async handleDeleteBusiness() {
        try {
            setLoading(true);
            const result = await apiManage_rbp.del_business_hour(this.state.currentId);
            if (result.affectedRows > 0) {
                GlobalNotification.success(i18n.t('business_hour_page_opening_time_data_delete_succeed'));
                this.init()
            } else {
                GlobalNotification.error(i18n.t('business_hour_page_opening_time_data_detele_failed'));
            }
            setLoading(false);
        } catch (error) {

        }
    }

    /**
     *
     * 新增一个营业时间
     */
    async onSaveBusinessHours() {
        try {
            const { startTime, endTime } = this.state
            // 判断结束时间
            const nowEndTime = endTime === '00:00' ? '24:00' : endTime
            if (timeDifference(nowEndTime, startTime) < 0) {
                GlobalNotification.warning(i18n.t('business_hour_page_starttime_less_then_endtime'));
                return
            }
            if (this.state.preferredMenu.length === 0) {
                GlobalNotification.warning(i18n.t('business_hour_page_had_not_select_preferred_menu'));
                return
            }
            const params = {
                alternative_menu: _.join(this.state.alternativeMenu, ','),
                end_time: nowEndTime,
                preferred_menu: _.join(this.state.preferredMenu, ','),
                start_time: startTime,
            }
            const isOverlap = this.state.tables.some((date) => {
                if (this.state.currentId === date.id) return false;
                const newStartTime = moment(params.start_time, 'HH:mm');
                const newEndTime = moment(params.end_time, 'HH:mm');
                const startTime = moment(date.start_time, 'HH:mm');
                const endTime = moment(date.end_time, 'HH:mm');
                return (
                    newStartTime.isBetween(startTime, endTime) ||
                    newEndTime.isBetween(startTime, endTime) ||
                    startTime.isBetween(newStartTime, newEndTime) ||
                    endTime.isBetween(newStartTime, newEndTime)
                );
            });
            if (isOverlap) {
                GlobalNotification.error(i18n.t('business_hour_page_time_phase_overlap'));
                return
            }
            if (this.state.currentId !== 0) {
                const result = await apiManage_rbp.patch_v2_business_hour(this.state.currentId, params);
                if (result.affectedRows > 0 && result.fieldCount === 0) {
                    GlobalNotification.success(i18n.t('google_text_edit_succeed'));
                    await this.initBusinessHourTable()
                } else {
                    GlobalNotification.error(i18n.t('google_text_edit_failed'));
                }
            } else {
                const result = await apiManage_rbp.post_v2_business_hour(params);
                if (result.affectedRows > 0 && result.fieldCount === 0) {
                    GlobalNotification.success(i18n.t('google_text_add_succeed'));
                    await this.initBusinessHourTable()
                } else {
                    GlobalNotification.error(i18n.t('google_text_add_failed'));
                }
            }

        } catch (error) {

        }
    }

    /**
     * 时间
     * @param value
     * @param key
     */
    handleDateChange(value: {
        startTime: Date | null;
        endTime: Date | null
    }) {
        // endTime 做特殊处理
        let valEndTime = moment(value.endTime).format('kk:mm');
        if (moment(value.endTime).hour() === 0 && moment(value.endTime).minute() > 0) {
            valEndTime = moment(value.endTime).format('HH:mm');
        }
        this.setState(state => ({
            startTime: value.startTime ? moment(value.startTime).format('HH:mm') : state.startTime,
            endTime: value.endTime ? valEndTime : state.endTime
        }))
    }

    // 营业时间
    businessHours(): JSX.Element {
        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'start_time',
                label: i18n.t('google_text_start_time'),
                options: {
                    sort: false,
                }
            },
            {
                name: 'end_time',
                label: i18n.t('google_text_end_time'),
            },
            {
                name: 'preferred_menu',
                label: i18n.t('business_hour_page_preferred_menu'),
                options: {
                    sort: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        const id = Number(_.get(this.state.tables, `[${dataIndex}].preferred_menu`, ''));
                        const menu = _.filter(this.state.menuList, item => {
                            return item.main_group_id === id;
                        })
                        return (
                            <div>
                                {
                                    _.get(menu, '[0].main_group_name', '')
                                }
                            </div>
                        )
                    }
                }
            },
            {
                name: 'alternative_menu',
                label: i18n.t('business_hour_page_alternative_menu'),
                options: {
                    sort: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        const id = _.get(this.state.tables, `[${dataIndex}].alternative_menu`, '');
                        const ids = _.split(id, ',');
                        return (
                            <div className='menuGroup'>
                                {
                                    (this.state.menuList || []).map((menu, index) => {
                                        if (_.indexOf(ids, (menu.main_group_id || 0).toString()) === -1) {
                                            return null
                                        }
                                        return <Typography variant='subtitle1' className='text' key={index}>
                                            {
                                                menu.main_group_name
                                            }
                                        </Typography>
                                    })
                                }
                            </div>
                        )
                    }
                }
            },
            {
                name: 'action',
                label: i18n.t('cash_box_page_operation'),
                options: {
                    sort: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <div className='business-hour-simple__table-actions'>
                                <ButtonComponent
                                    action='VIEW'
                                    handleClick={() => {
                                        const id = _.get(this.state.tables, `[${dataIndex}].alternative_menu`, '');
                                        const ids = _.split(id, ',');
                                        const alternativeMenuIds = [] as number[];
                                        const allMenuIds = this.state.menuList.map(item => item.main_group_id);
                                        for (const id of ids) {
                                            allMenuIds.includes(Number(id)) && alternativeMenuIds.push(Number(id));
                                        }
                                        this.setState({
                                            addNewBusinessHours: true,
                                            startTime: this.state.tables[dataIndex].start_time,
                                            endTime: this.state.tables[dataIndex].end_time,
                                            alternativeMenu: alternativeMenuIds,
                                            preferredMenu: [Number(_.get(this.state.tables, `[${dataIndex}].preferred_menu`, 0))],
                                            currentId: _.get(this.state.tables, `[${dataIndex}].id`, 0)
                                        })
                                    }}
                                />
                                <ButtonComponent
                                    action='DELETE'
                                    handleClick={() => {
                                        this.setState({
                                            currentId: _.get(this.state.tables, `[${dataIndex}].id`, 0),
                                            deleteOpen: true
                                        })
                                    }}
                                />
                            </div>
                        )
                    }
                }
            }
        ]
        const menuOptions = (this.state.menuList || []).map((item) => ({
            value: `${item.main_group_id ?? ''}`,
            label: item.main_group_name || '',
        }));
        const { simpleMenuModal, isComplex, initialLoadReady } = this.state;

        return (
            <Fragment>
            <Box className="business-hour-simple__page-head" display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1.5}>
                <Typography variant="h3" className="title_text">
                    {i18n.t('business_hour_page_opening_time')}
                </Typography>
                <IOSSwitch
                    checked={isComplex}
                    disabled={!initialLoadReady}
                    onChange={() => {
                        this.onChange();
                    }}
                />
            </Box>
            <Grid className='simple business-hour-simple'>
                <div className='business-hour-simple__panel'>
                    <Grid className='_top'>
                        <Typography variant='subtitle1' className='menu_text'>
                            {i18n.t('business_hour_compound_menu_settings')}
                        </Typography>
                        <ButtonComponent
                            action='SAVE'
                            handleClick={() => {
                                this.save()
                            }}
                            disabled={
                                _.xor(this.state.oldHideMenu, this.state.hideMenu).length === 0 &&
                                _.xor(this.state.oldRequiredMenu, this.state.requiredMenu).length === 0 &&
                                this.state.isRepeatedly
                            }
                        />
                    </Grid>
                    <div className="business-hour-compound business-hour-simple__compound-menu">
                        <div className="business-hour-compound-expand__section">
                            <Typography className="business-hour-compound-expand__section-title" component="div">
                                {i18n.t('business_hour_page_required_menu')}
                            </Typography>
                            <div className="business-hour-compound-expand__chips">
                                {this.state.requiredMenu.map((mid) => (
                                    <Chip
                                        key={`required-${mid}`}
                                        label={this.simpleMenuLabel(mid)}
                                        onDelete={() => this.onChangeMenu(mid, 1, this.state.requiredMenu)}
                                        deleteIcon={
                                            <MingcuteCloseFillIcon
                                                className="business-hour-compound-menu-chip__close"
                                                aria-hidden
                                                focusable="false"
                                            />
                                        }
                                        className="business-hour-compound-menu-chip"
                                        variant="outlined"
                                    />
                                ))}
                                <Button
                                    variant="outlined"
                                    className="business-hour-compound-add-menu-btn"
                                    endIcon={
                                        <IcRoundPlusIcon
                                            className="business-hour-compound-add-menu-btn__plus"
                                            aria-hidden
                                            focusable="false"
                                        />
                                    }
                                    onClick={() => this.setState({ simpleMenuModal: { kind: 'required' } })}
                                >
                                    {i18n.t('business_hour_compound_add_menu_plus')}
                                </Button>
                            </div>
                        </div>
                        <div className="business-hour-compound-expand__section">
                            <Typography className="business-hour-compound-expand__section-title" component="div">
                                {i18n.t('business_hour_page_default_hide_menu')}
                            </Typography>
                            <div className="business-hour-compound-expand__chips">
                                {this.state.hideMenu.map((mid) => (
                                    <Chip
                                        key={`hide-${mid}`}
                                        label={this.simpleMenuLabel(mid)}
                                        onDelete={() => this.onChangeMenu(mid, 2, this.state.hideMenu)}
                                        deleteIcon={
                                            <MingcuteCloseFillIcon
                                                className="business-hour-compound-menu-chip__close"
                                                aria-hidden
                                                focusable="false"
                                            />
                                        }
                                        className="business-hour-compound-menu-chip"
                                        variant="outlined"
                                    />
                                ))}
                                <Button
                                    variant="outlined"
                                    className="business-hour-compound-add-menu-btn"
                                    endIcon={
                                        <IcRoundPlusIcon
                                            className="business-hour-compound-add-menu-btn__plus"
                                            aria-hidden
                                            focusable="false"
                                        />
                                    }
                                    onClick={() => this.setState({ simpleMenuModal: { kind: 'hide' } })}
                                >
                                    {i18n.t('business_hour_compound_add_menu_plus')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='business-hour-simple__panel business-hour-simple__panel--hours'>
                    <Grid className='table-top'>
                        <Typography variant='h3' className='menu_text'>
                            {i18n.t('business_hour_page_opening_time')}
                        </Typography>
                        <ButtonComponent
                            action='ADD'
                            handleClick={() => {
                                this.setState({
                                    addNewBusinessHours: true,
                                    startTime: '00:00',
                                    endTime: '00:00',
                                })
                            }}
                        />
                    </Grid>

                    <Grid className='table'>
                {
                    this.state.addNewBusinessHours ?
                        <Grid className='add_new'>
                            <Grid className='search-picker'>
                                <Grid className='picker business-hour-simple__time-range-compact-wrap'>
                                    <CommonInput
                                        inputType={'TIME_RANGE_COMPACT'}
                                        rangeHandleChangePicker={(dates) => {
                                            if (dates) {
                                                this.handleDateChange({ startTime: dates[0], endTime: dates[1] })
                                            }
                                        }}
                                        rangeValue={[moment(this.state.startTime, 'kk:mm').toDate(), moment(this.state.endTime, 'kk:mm').toDate()]}
                                        size={'small'}
                                    />
                                </Grid>
                                <Grid>
                                    <ButtonComponent
                                        action='BACK'
                                        handleClick={() => {
                                            this.setState({
                                                addNewBusinessHours: false,
                                                startTime: '00:00',
                                                endTime: this.state.endTime === '00:00' ? '24:00' : this.state.endTime,
                                                alternativeMenu: [],
                                                preferredMenu: [],
                                                currentId: 0
                                            })
                                        }}
                                    />
                                    <ButtonComponent
                                        action='SAVE'
                                        handleClick={() => {
                                            // 新增
                                            this.onSaveBusinessHours()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <div className="business-hour-compound business-hour-simple__compound-menu business-hour-simple__add-hours-menus">
                                <div className="business-hour-compound-expand__section">
                                    <Typography className="business-hour-compound-expand__section-title" component="div">
                                        {i18n.t('business_hour_page_preferred_menu')}
                                    </Typography>
                                    <div className="business-hour-compound-expand__chips">
                                        {this.state.preferredMenu.map((mid) => (
                                            <Chip
                                                key={`add-hours-preferred-${mid}`}
                                                label={this.simpleMenuLabel(mid)}
                                                onDelete={() => this.setState({ preferredMenu: [] })}
                                                deleteIcon={
                                                    <MingcuteCloseFillIcon
                                                        className="business-hour-compound-menu-chip__close"
                                                        aria-hidden
                                                        focusable="false"
                                                    />
                                                }
                                                className="business-hour-compound-menu-chip"
                                                variant="outlined"
                                            />
                                        ))}
                                        <Button
                                            variant="outlined"
                                            className="business-hour-compound-add-menu-btn"
                                            endIcon={
                                                <IcRoundPlusIcon
                                                    className="business-hour-compound-add-menu-btn__plus"
                                                    aria-hidden
                                                    focusable="false"
                                                />
                                            }
                                            onClick={() => this.setState({ simpleMenuModal: { kind: 'preferred' } })}
                                        >
                                            {i18n.t('business_hour_compound_add_menu_plus')}
                                        </Button>
                                    </div>
                                </div>
                                <div className="business-hour-compound-expand__section">
                                    <Typography className="business-hour-compound-expand__section-title" component="div">
                                        {i18n.t('business_hour_page_alternative_menu')}
                                    </Typography>
                                    <div className="business-hour-compound-expand__chips">
                                        {this.state.alternativeMenu.map((mid) => (
                                            <Chip
                                                key={`add-hours-alt-${mid}`}
                                                label={this.simpleMenuLabel(mid)}
                                                onDelete={() => this.onChangeMenu(mid, 4, this.state.alternativeMenu)}
                                                deleteIcon={
                                                    <MingcuteCloseFillIcon
                                                        className="business-hour-compound-menu-chip__close"
                                                        aria-hidden
                                                        focusable="false"
                                                    />
                                                }
                                                className="business-hour-compound-menu-chip"
                                                variant="outlined"
                                            />
                                        ))}
                                        <Button
                                            variant="outlined"
                                            className="business-hour-compound-add-menu-btn"
                                            endIcon={
                                                <IcRoundPlusIcon
                                                    className="business-hour-compound-add-menu-btn__plus"
                                                    aria-hidden
                                                    focusable="false"
                                                />
                                            }
                                            onClick={() => this.setState({ simpleMenuModal: { kind: 'alternative' } })}
                                        >
                                            {i18n.t('business_hour_compound_add_menu_plus')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Grid> :
                        <Table
                            data={this.state.tables || []}
                            columns={columns}
                            selectableRowsHideCheckboxes={true}
                            pagination={false}
                            selectableRowsHeader={false}
                            onRowSelectionChange={() => {

                            }}
                        />
                }
                    </Grid>
                </div>
            </Grid>
                <Dialog
                    open={!!simpleMenuModal}
                    onClose={this.closeSimpleMenuModal}
                    className="business-hour-compound-menu-dialog"
                    maxWidth={false}
                    PaperProps={{ elevation: 0 }}
                >
                    <DialogContent sx={{ p: 0 }}>
                        {simpleMenuModal && (
                            <>
                                <div className="business-hour-compound-menu-dialog__header">
                                    <div>
                                        <div className="business-hour-compound-menu-dialog__title">
                                            {i18n.t('business_hour_compound_add_menu_title')}
                                        </div>
                                        <div className="business-hour-compound-menu-dialog__subtitle">
                                            {simpleMenuModal.kind === 'required'
                                                ? i18n.t('business_hour_page_required_menu')
                                                : simpleMenuModal.kind === 'hide'
                                                    ? i18n.t('business_hour_page_default_hide_menu')
                                                    : simpleMenuModal.kind === 'preferred'
                                                        ? i18n.t('business_hour_page_preferred_menu')
                                                        : i18n.t('business_hour_page_alternative_menu')}
                                        </div>
                                    </div>
                                    <IconButton size="small" onClick={this.closeSimpleMenuModal} aria-label="close">
                                        <MingcuteCloseFillIcon
                                            className="business-hour-compound-menu-chip__close"
                                            aria-hidden
                                            focusable="false"
                                        />
                                    </IconButton>
                                </div>
                                <div className="business-hour-compound-menu-dialog__grid">
                                    {menuOptions.map((optionItem) => {
                                        const kind = simpleMenuModal.kind;
                                        const optionId = Number(optionItem.value);
                                        const active =
                                            kind === 'required'
                                                ? this.state.requiredMenu.includes(optionId)
                                                : kind === 'hide'
                                                    ? this.state.hideMenu.includes(optionId)
                                                    : kind === 'preferred'
                                                        ? this.state.preferredMenu.includes(optionId)
                                                        : this.state.alternativeMenu.includes(optionId);
                                        return (
                                            <button
                                                type="button"
                                                key={optionItem.value}
                                                className={
                                                    active
                                                        ? 'business-hour-compound-menu-dialog__menu-item business-hour-compound-menu-dialog__menu-item--on'
                                                        : 'business-hour-compound-menu-dialog__menu-item business-hour-compound-menu-dialog__menu-item--off'
                                                }
                                                disabled={
                                                    !active &&
                                                    this.simpleMenuModalOptionDisabled(kind, optionItem.value, active)
                                                }
                                                onClick={() => {
                                                    const id = Number(optionItem.value);
                                                    if (kind === 'required') {
                                                        this.onChangeMenu(id, 1, this.state.requiredMenu);
                                                    } else if (kind === 'hide') {
                                                        this.onChangeMenu(id, 2, this.state.hideMenu);
                                                    } else if (kind === 'preferred') {
                                                        this.setState({ preferredMenu: [id] });
                                                    } else {
                                                        this.onChangeMenu(id, 4, this.state.alternativeMenu);
                                                    }
                                                }}
                                            >
                                                {optionItem.label}
                                            </button>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </DialogContent>
                </Dialog>
            </Fragment>
        )
    }

    // 复合型营业时间
    ComplexBusinessHours(): JSX.Element {
        const { menuList, businessHour2, turn_dishes, turn_mins, max_turn, isComplex, initialLoadReady } = this.state;
        return (
            <div>
                <BusinessHourCompound
                    menuList={menuList}
                    businessHour2={businessHour2}
                    handleChange={(value) => {
                        this.setState({
                            businessHour2: value
                        })
                    }}
                    onSave={this.onSave}
                    defaultTurnDishes={turn_dishes}
                    defaultTurnMins={turn_mins}
                    defaultMaxRound={max_turn}
                    sectionTitle={isComplex ? i18n.t('business_hour_page_complex_opening_time') : i18n.t('business_hour_page_opening_time')}
                    complexModeToggle={(
                        <IOSSwitch
                            checked={isComplex}
                            disabled={!initialLoadReady}
                            onChange={() => {
                                this.onChange();
                            }}
                        />
                    )}
                />
            </div>
        )
    }

    /** 拉取菜单与复合型营业时间并写入 state */
    private async initBusinessHour2() {
        const [menuList, rawBusinessHour2] = await Promise.all([
            this.getMenus(),
            this.getBusinessHour2(),
        ]);
        const menuIds = menuList.map(menu => `${menu.main_group_id}`);
        /** 浅拷贝后再调整顺序，避免与并发请求返回的引用产生意外共享 */
        const businessHour2 = [...(rawBusinessHour2 ?? [])];
        //把周日挪到后面，调整数据位置
        const item = businessHour2.shift() || {};
        // 自定义日期在周日后面
        if (businessHour2.length > 6) {
            const removed = businessHour2.splice(6);
            businessHour2.push(item, ...removed);
        } else {
            businessHour2.push(item);
        }
        businessHour2.forEach(business => {
            business.value = this.removeNotExistMenuIds(business.value || [], menuIds);
            business.value2 = this.removeNotExistMenuIds(business.value2 || [], menuIds);
        });
        this.setState({
            businessHour2,
            menuList
        });
    }

    removeNotExistMenuIds = (value: BusinessHourValue[], menuIds: string[]) => {
        for (const item of value) {
            item.alternative_menu = (item.alternative_menu || []).filter(ele => menuIds.includes(ele));
            item.default_menu = (item.default_menu || []).filter(ele => menuIds.includes(ele));
            item.hide_menu = (item.hide_menu || []).filter(ele => menuIds.includes(ele));
            item.preferred_menu = (item.preferred_menu || []).filter(ele => menuIds.includes(ele));
        }
        return value;
    }

    // 获取菜单数据
    async getMenus() {
        const result = await apiManage_rbp.get_menus_v3({
            type: 0
        })
        if (_.get(result, 'error')) {
            return []
        }
        return result
    }

    // 获取复合型营业时间数据
    async getBusinessHour2() {
        const result = await apiManage_rbp.get_business_hour2()
        if (_.get(result, 'error')) {
            return this.generateData()
        }
        else {
            if (result.length === 0) {
                return this.generateData()
            }
        }
        return result
    }

    /**
     * 没有数据时生成营业时间数据
     * @returns
     */
    generateData(): BusinessHour2[] {
        const result: BusinessHour2[] = [];
        const { turn_dishes, turn_mins, max_turn } = this.state;
        for (let i = 0; i < 7; i++) {
            const data = generateBusinessHour2(`${i}`, '0', turn_dishes, turn_mins, max_turn);
            result.push(data)
        }
        return result
    }

    // 保存复合型营业时间
    onSave = async (data: PostBusinessHour2Params[]) => {
        if (this.savingGuestClosing) {
            return
        }
        this.savingGuestClosing = true;
        let endFlag: boolean = false;
        // 校验开始时间与结束时间
        for (const v of data) {
            if (timeDifference(v.end_time, v.start_time) < 0) {
                GlobalNotification.error(`${getDate(Number(v.week))}: ${i18n.t('business_hour_page_starttime_less_then_endtime')}`);
                endFlag = true;
                break;
            } else {
                // 重置标识
                endFlag = false;
                this.savingGuestClosing = false;
            }
        }
        if (endFlag) return;
        setLoading(true);
        const result = await apiManage_rbp.post_business_hour2(data);
        setLoading(false);
        // 修改成功
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('google_text_update_successfully'))
        }
        // 修改失败
        else {
            GlobalNotification.error(i18n.t('google_text_verify_failed'))
        }

        this.savingGuestClosing = false;
    }

    // ***************
    // VIEW
    // ***************

    /** 仅内容区骨架：标题与开关在各自内容区顶部展示，此处仅占位块 */
    renderContentSkeleton() {
        return (
            <Box className="business-hour__content-skeleton" aria-busy="true">
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Skeleton variant="rounded" height={48} animation="wave" />
                    <Skeleton variant="rounded" height={160} animation="wave" />
                    <Skeleton variant="rounded" height={160} animation="wave" />
                    <Skeleton variant="rounded" height={120} animation="wave" sx={{ maxWidth: 480 }} />
                </Stack>
            </Box>
        );
    }

    render() {
        const { isComplex, deleteOpen, initialLoadReady } = this.state;
        return (
            <Box className='business-hour'>
                <Card
                    className='business-hour-card'
                    contentRender={(
                        <Box>
                            {
                                initialLoadReady
                                    ? (isComplex ? this.ComplexBusinessHours() : this.businessHours())
                                    : this.renderContentSkeleton()
                            }
                        </Box>
                    )}
                />
                {
                    deleteOpen &&
                    <AlertDialog
                        open={true}
                        variant="delete"
                        title={i18n.t('business_hour_page_delete_business_data')}
                        onCancel={() => {
                            this.setState({
                                deleteOpen: false
                            })
                        }}
                        onConfirm={() => {
                            this.setState({
                                deleteOpen: false
                            }, () => {
                                this.handleDeleteBusiness()
                            })

                        }}
                    />
                }
            </Box>
        )
    }
}

export default BusinessHourPage;

// ***************
// TYPE
// ***************

type State = {
    // 营业时间 | 复合型营业时间
    isComplex: boolean;
    // 必选菜单
    requiredMenu: Array<number>;
    // 隐藏菜单
    hideMenu: Array<number>;
    // 选中菜单
    selectMenu: Array<number>;
    oldRequiredMenu: Array<number>;
    oldHideMenu: Array<number>;
    tables: Array<any>;
    deleteOpen: boolean;
    currentId: number;
    // 新增营业时间
    addNewBusinessHours: boolean;
    // 首选菜单
    preferredMenu: Array<number>;
    // 备选菜单
    alternativeMenu: Array<number>;
    endTime: string;
    startTime: string;
    // 菜单列表
    menuList: FirstMenu[];
    // 复合型营业时间数据
    businessHour2: BusinessHour2[];
    // 重复提交
    isRepeatedly: boolean;
    // 轮次时间
    turn_mins: number;
    // 每人每轮点餐数量
    turn_dishes: number;
    // 最大点餐回合数
    max_turn: number;
    /** 首次 init + initBusinessHour2 是否已完成 */
    initialLoadReady: boolean;
    /** 简单模式：必选/隐藏/新增时段首选与备选 — 共用「新增菜单」弹窗 */
    simpleMenuModal: null | { kind: 'required' | 'hide' | 'preferred' | 'alternative' };

}

type Props = {}